// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsCard_wrapper__34Ipe","thumbnail":"NewsCard_thumbnail__1ncQk","content":"NewsCard_content__9a-GD","date":"NewsCard_date__wWEU3","excerpt":"NewsCard_excerpt__nWByT"};